import React from 'react';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import GroupsIcon from '@mui/icons-material/Groups';

import { stringToColor } from '../utils/stringToColor';

interface ClubBadgeOverlayProps {
    name: string;
    logo?: string | null;
}

// "Which club is this from" badge for the cross-club feed cards: the club
// logo (or a coloured initial) plus the full club name, pinned to the
// top-left of the cover image. The name wraps rather than truncating so it
// stays fully readable on narrow cards. The image must sit in a
// `position: relative` container.
export const ClubBadgeOverlay = ({ name, logo }: ClubBadgeOverlayProps) => (
    <Box
        sx={{
            position: 'absolute',
            top: 10,
            left: 10,
            zIndex: 1,
            maxWidth: 'calc(100% - 20px)',
            display: 'flex',
            alignItems: 'center',
            gap: 0.75,
            pr: 1,
            pl: 0.5,
            py: 0.5,
            borderRadius: 5,
            bgcolor: 'rgba(0, 0, 0, 0.62)',
            backdropFilter: 'blur(4px)',
            WebkitBackdropFilter: 'blur(4px)',
        }}
    >
        <Avatar
            src={logo ?? undefined}
            alt={name}
            sx={{
                width: 22,
                height: 22,
                fontSize: 12,
                fontWeight: 600,
                flexShrink: 0,
                bgcolor: logo ? 'background.paper' : stringToColor(name),
            }}
        >
            {name ? name[0].toUpperCase() : <GroupsIcon sx={{ fontSize: 14 }} />}
        </Avatar>
        <Typography
            variant="caption"
            sx={{
                color: 'common.white',
                fontWeight: 500,
                lineHeight: 1.2,
                whiteSpace: 'normal',
            }}
        >
            {name}
        </Typography>
    </Box>
);

export default ClubBadgeOverlay;
